export default __webpack_public_path__ + "static/media/marker_default.b1b5df86.png";